import React from 'react';
var defaultContext = {
    dividerIndexes: [],
    expandable: false,
    hiddenColumns: [],
};
export var TableContext = React.createContext(defaultContext);
export var useTable = function () { return React.useContext(TableContext); };
